// extracted by mini-css-extract-plugin
export var container = "resumeContainer-module--container--MEq5S";
export var resume = "resumeContainer-module--resume--XZsoR";
export var resumeTitle = "resumeContainer-module--resumeTitle--FeDzB";